import React, { Component } from 'react';
import Swal from 'sweetalert2';
// import _ from 'lodash';
import Loading from '../../../views/Loading';
import { Grid, Col, Row } from 'react-bootstrap';
import { dominio } from "../../../routes_backend/routes.jsx";

import Card from '../../../components/Card/Card';





class FfactSAP extends Component {
  constructor(props) {
    super(props);
    this.state = {
      message: '',
      oc: '',
      isLoading: false,
     
    };
  }

  // Manejar el cambio en el campo de entrada de OT
  handleOtsChange = (e) => {
    this.setState({ oc: e.target.value });
  };

  handleOtsChangeOC = (e) => {
    this.setState({ oc2: e.target.value });
  };



  // Función para procesar la OT
  handleProcessOT = async () => {
    const { oc } = this.state;

    if (!oc) {
      Swal.fire('Error', 'Por favor, ingrese un número de Factura.', 'error');
      return;
    }

    try {
      this.setState({
        isLoading: true,

      });
    


        const response = await fetch(`${dominio}/postOVFSAP/${oc}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },        
      });

      const result = await response.json();

      if (response.ok) {
        this.setState({
        isLoading: false,

      });
    Swal.fire({
        title: 'Proceso Completo',
        text: result.message || 'Procesado correctamente.',
        icon: 'success',
        
    });
    
} else {
    this.setState({
        isLoading: false,

      });
    Swal.fire({
        title: 'Error',
        text: result.error || result.message || 'Ocurrió un error durante el procesamiento.',
        icon: 'error',
    });
}
    } catch (error) {
        this.setState({
        isLoading: false,

      });
      Swal.fire({
        title: 'Error',
        text: `No se pudo conectar con el servidor: ${error.message}`,
        icon: 'error',
      });
       
    }
  };


   handleProcessOTOC = async () => {
    const { oc2 } = this.state;

    if (!oc2) {
      Swal.fire('Error', 'Por favor, ingrese un número de Factura.', 'error');
      return;
    }

    try {
      this.setState({
        isLoading: true,

      });
    
       let oc = oc2

        const response = await fetch(`${dominio}/postOVPSAP/${oc}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },        
      });

      const result = await response.json();

      if (response.ok) {
    Swal.fire({
        title: 'Proceso Completo',
        text: result.message || 'Procesado correctamente.',
        icon: 'success',
        
    });
    this.setState({
        isLoading: false,

      });
} else {
    Swal.fire({
        title: 'Error',
        text: result.error || result.message || 'Ocurrió un error durante el procesamiento.',
        icon: 'error',
    });
     this.setState({
        isLoading: false,

      });
}
    } catch (error) {
      Swal.fire({
        title: 'Error',
        text: `No se pudo conectar con el servidor: ${error.message}`,
        icon: 'error',
      });
       this.setState({
        isLoading: false,

      });
    }
  };
 



  render() {
    const { oc, oc2, isLoading } = this.state;




    return (
      <div className="content" style={{ textAlign: 'center', alignItems: 'center' }}>
        <Grid fluid>
          <Row>
            <Col md={12}>
              <Card
                title="Ingresar Factura u Ordenes Compra MACIZO"
                ctTableFullWidth
                ctTableResponsive
                content={
                  <div className="content d-flex justify-content-center align-items-center vh-100">
  <div className="row w-100 text-center">
    <div className="col-md-6 d-flex flex-column align-items-center">
      <h3>Facturas Ffacsa Macizo</h3>
      <input
        type="text"
        placeholder="Ingrese el número Factura"
        value={oc}
        onChange={this.handleOtsChange}
        style={{ padding: '10px', marginBottom: '10px', width: '80%' }}
      />
      <br />
      <br />
      <button onClick={this.handleProcessOT} className="btn btn-primary">
        Ingresar
      </button>
    </div>
    <div className="col-md-6 d-flex flex-column align-items-center">
      <h3>Ordenes Compra Ffacsa Macizo</h3>
      <input
        type="text"
        placeholder="Ingrese el número Orden Compra"
        value={oc2}
        onChange={this.handleOtsChangeOC}
        style={{ padding: '10px', marginBottom: '10px', width: '80%' }}
      />
      <br />
      <br />
      <button onClick={this.handleProcessOTOC} className="btn btn-primary">
        Ingresar
      </button>
    </div>
  </div>
</div>

                }
              />
            </Col>
          </Row>
        </Grid>
        {isLoading && <Loading />}
      </div>
    );
  }
}



// const style = {
//   errorMessage: {
//     fontWeight: 'bold',
//     fontSize: '12px',
//     height: '10px',
//     color: 'red',
//   },
//   text: {
//     textAlign: 'center',
//     backgroundColor: '#dddddd',
//     border: '2px solid',
//     color: '#000',
//     fontSize: '14px',
//     fontWeight: 'bold',
//   },
//   ColorCell: {
//     textAlign: 'center',
//     border: '2px solid',
//     color: '#000',
//     fontSize: '14px',
//   },
//   row: {
//     display: 'flex',
//     alignItems: 'center',
//   },
// };
export default FfactSAP;
